import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import { getInvitationStatus } from "api/services/user-service";
import { useCallback } from "react";
import useApiCall from "./useApiCall";

export const useGetInvitationStatus= () => {
    const { callAPI, loading } = useApiCall(getInvitationStatus, '', 'getInvitationStatus.error');

    const fetchInvitationStatus = useCallback(async (invitationId: string) => {
        const resp = await callAPI({ invitationId });
        return resp;
    }, [callAPI]);

    return {fetchInvitationStatus, fetchingInvitationStatus: loading };
}